module.exports = __webpack_public_path__ + "static/img/4.aa99ae6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/4.png
// module id = c6fT
// module chunks = 0